import React from "react";
import { connect } from "react-redux";
import { updateUserAlgConfidenceSettings, updateAlgConfidenceSettings } from "../../../../../../actions";
import {
    Backdrop,
    Modal
} from "@mui/material";
import { findLatestVersion } from "../../../../../../utils/versions";
import AlgorithmSettingLayout from './AlgorithmSettingLayout'
import _ from 'lodash';

const AlgorithmSettingModal = ({
    autofillSettings,
    algorithmSettingModalOpen,
    setAlgorithmSettingModalOpen,
    updateUserAutofillSettings,
    device,
    initialVectorType,
    algVersion,
    updateAlgConfidenceSettings,
    latestAlgVersion,
    uniqueVectorTypes,
    devicesVectorTypes,
    algorithmConfidence,
    vectorTypeOptions,
    defaultAlgorithmConfidenceThreshold
}) => {
    const onClose = () => setAlgorithmSettingModalOpen(false);

    return (
        <Modal
            open={algorithmSettingModalOpen}
            onClose={onClose}
            BackdropComponent={Backdrop}
        >
            <AlgorithmSettingLayout
                updateUserAutofillSettings={updateUserAutofillSettings}
                autofillSettings={autofillSettings}
                onClose={onClose}
                device={device}
                initialVectorType={initialVectorType}
                algVersion={algVersion}
                latestAlgVersion={latestAlgVersion}
                uniqueVectorTypes={uniqueVectorTypes}
                devicesVectorTypes={devicesVectorTypes}
                algorithmConfidence={algorithmConfidence}
                updateAlgConfidenceSettings={updateAlgConfidenceSettings}
                vectorTypeOptions={vectorTypeOptions}
                defaultAlgorithmConfidenceThreshold={defaultAlgorithmConfidenceThreshold}
            />
        </Modal>
    );
};

const mapStateToProps = (state) => {
    const { autofillSettings } = state.user;
    const algorithmConfidence = state?.organization?.algorithmConfidence

    let selectedDevice = state.devices?.selectedDevice || "";
    let device = state.devices?.[selectedDevice];

    const algVersions = Object.values(state.devices).reduce((pre, cur) => {
        if (cur?.algVersion) {
            return [...pre, cur?.algVersion];
        }
        return pre;
    }, []);
    const vectorTypes = Object.values(state.devices).reduce((pre, cur) => {
        if (cur?.vectorType) {
            return [...pre, cur?.vectorType];
        }
        return pre;
    }, []);

    let devicesVectorTypes = [];
    Object.values(state.devices).forEach((d) => {
        const { displayName, vectorType, algVersion, env } = d;
        if (env === process.env.REACT_APP_ENV.toUpperCase()) {
            devicesVectorTypes.push({ displayName, vectorType, algVersion });
        }
    });

    const uniqueVectorTypes = [...new Set(vectorTypes)];

    let vectorType = uniqueVectorTypes[0];
    if (uniqueVectorTypes.includes(device?.['vectorType'])) {
        vectorType = device?.['vectorType']
    }

    const latestAlgVersion = findLatestVersion(algVersions);
    const possibleVectorTypes = state?.algVersion?.[latestAlgVersion] || {
        mosquito: {},
        tick: {},
    }
    const vectorTypeOptions = Object.values(possibleVectorTypes || {}).reduce((arr, cur) => {
        const tmpArr = []
        let top = {}
        for (const [curKey, value] of Object.entries(cur)) {
            if (value === 'all') {
                top = {
                    value: curKey,
                    label: curKey
                }
            } else {
                tmpArr.push({
                    value: curKey,
                    label: `${value} (${curKey.startsWith('m') ? 'mosquito' : 'tick'})`
                })
            }

        }
        arr = [top, ...(_.sortBy(tmpArr, 'label') || []), ...arr]
        return arr
    }, [])

    const defaultAlgorithmConfidenceThreshold = state.organization?.['defaultAlgorithmConfidenceThreshold']

    return {
        autofillSettings,
        initialVectorType: vectorType,
        algVersion: device?.algVersion || "v2.1.1",
        uniqueVectorTypes,
        latestAlgVersion: findLatestVersion(algVersions),
        devicesVectorTypes,
        algorithmConfidence,
        vectorTypeOptions,
        defaultAlgorithmConfidenceThreshold
    };
};

export default connect(mapStateToProps, { updateUserAlgConfidenceSettings, updateAlgConfidenceSettings })(
    AlgorithmSettingModal
);
